import React from "react";
import { motion } from "framer-motion";
import { TransformButton } from "./CtaButton";
interface SystemItem {
  emoji: string;
  tag: string;
  title: string;
  body: string;
}
const systems: SystemItem[] = [{
  emoji: "📘",
  tag: "Sistema #1",
  title: "Instala tu Negocio de Reparaciones",
  body: "Deja de trabajar como un aficionado y construye las bases de un negocio técnico profesional desde el primer día. Organiza la estructura de tu negocio, define procesos y evita los errores que frenan el crecimiento."
}, {
  emoji: "💰",
  tag: "Sistema #2",
  title: "Cobra Como un Técnico Premium",
  body: "Uno de los mayores errores es cobrar “lo que parece justo”. Aprende a calcular precios rentables considerando tus costos, tiempo y utilidad, para dejar de regalar tu trabajo."
}, {
  emoji: "⚙️",
  tag: "Sistema #3",
  title: "Reparaciones Sin Caos",
  body: "Implementa un flujo de trabajo claro desde que recibes el equipo hasta que lo entregas. Menos errores, menos retrabajos, más rapidez, más organización y más confianza."
}, {
  emoji: "🤝",
  tag: "Sistema #4",
  title: "Clientes que Recomiendan",
  body: "Una reparación no debería terminar cuando entregas el electrodoméstico. Genera una experiencia que aumente la probabilidad de que el cliente vuelva y te recomiende."
}, {
  emoji: "📈",
  tag: "Sistema #5",
  title: "Clientes Todos los Meses",
  body: "Estrategias simples para mantener un flujo constante de oportunidades mediante WhatsApp, TikTok y recomendaciones locales, sin depender únicamente del boca a boca."
}, {
  emoji: "📂",
  tag: "Sistema #6",
  title: "Negocio Listo para Operar",
  body: "El corazón del sistema: +300 documentos, plantillas, contratos, órdenes de servicio, garantías, inventarios, checklists y formatos profesionales listos para editar, imprimir y utilizar hoy."
}];
export function SystemsSection() {
  return <section className="w-full bg-neutral-950 py-14" data-id="element-175" data-mp="1be0e5ulgqrgz">
      <div className="mx-auto max-w-lg px-4" data-id="element-176" data-mp="35va9hfqxmvaf">
        <h2 className="text-center font-display text-2xl font-extrabold leading-tight text-white sm:text-3xl" data-id="element-177" data-mp="35ugyu3ourln0">
          Esto es exactamente lo que{" "}
          <span className="text-amber-400" data-id="element-178" data-mp="2vz6w1dqmra86">instalarás</span> en tu negocio
        </h2>

        <div className="mt-8 space-y-4" data-id="element-179" data-mp="30wfihqita0f8">
          {systems.map((s, i) => <motion.article key={s.tag} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: "-60px"
        }} transition={{
          duration: 0.4,
          delay: i * 0.04
        }} className="rounded-2xl border border-white/10 bg-neutral-900 p-5" data-id="element-180" data-mp="3on2schcaf04f" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-181" data-mp="3jlvlqllvs6zc">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-amber-400/15 text-2xl" data-id="element-182" data-mp="2396yy12df1fv">
                  {s.emoji}
                </span>
                <div data-id="element-183" data-mp="qaod4hf7o14p">
                  <span className="font-display text-[11px] font-bold uppercase tracking-widest text-amber-400" data-id="element-184" data-mp="qa54xsfd4r3v">
                    {s.tag}
                  </span>
                  <h3 className="font-display text-lg font-extrabold leading-tight text-white" data-id="element-185" data-mp="zbmib31dyeov">
                    {s.title}
                  </h3>
                </div>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-white/70" data-id="element-186" data-mp="v86p6goiywgx">
                {s.body}
              </p>
            </motion.article>)}
        </div>

        <div className="mt-8 flex justify-center" data-id="element-187" data-mp="2mx0tdto7o3f">
          <TransformButton label="Quiero instalar estos 6 sistemas" data-id="element-188" data-mp="gciec8opbb42" />
        </div>
      </div>
    </section>;
}